Librarian.Html5Uploader = new Class({
    Implements: [Options],
    options: {
        chunkSize: 3 * 1024 * 1024,
        chunkUrl: null,
        completeUrl: null,
        importOptions: null,
        waitForComplete: false,
        onFileSuccess: null,
        onFileFailure: null,
        onComplete: null
    },

    files: [],
    successCount: 0,
    failureCount: 0,

    initialize: function(options) {
        this.setOptions(options);

        if (!this.options.chunkUrl)
            this.options.chunkUrl = Librarian.path.getUploadUrl("upufch");

        if (!this.options.completeUrl)
            this.options.completeUrl = Librarian.path.getUploadUrl("upufchc");
    },

    uploadFiles: function(fileList) {
        for (var i = 0; i < fileList.length; i++) {
            var file = fileList[i];
            this.uploadFile(file);
        }
    },

    uploadFile: function(file) {
        file.chunk = 0;
        file.status = "pending";

        this.files.push(file);

        // Start uploading
        this.uploadChunk(file);
    },

    uploadChunk: function(file) {
        var chunkSize = this.options.chunkSize,
            start = file.chunk * chunkSize,
            end = ++file.chunk * chunkSize;

        var chunk = file.slice(start, end);

        var url = this.options.chunkUrl + "&out=cjson&fname=" + encodeURIComponent(file.name) + "&foffset=" + start + "&fsize=" + file.size;

        if (this.options.importOptions)
            url += "&exi=true";
        else if (this.options.waitForComplete)
            url += "&wait=true&comp=true";

        var request = new Librarian.Request.JSON({
            url: url,
            method: "POST",
            data: chunk,
            headers: { "Content-Type": "application/octet-stream" },
            urlEncoded: false,
            onSuccess: function (status) {
                file.fileId = status.fileId;

                if (end >= file.size)
                    this.uploadComplete(file);
                else
                    this.uploadChunk(file);
            }.bind(this),
            onFailure: function(error) {
                this.onFileFailure(file, error);
            }.bind(this)

        });

        request.send();
    },

    uploadComplete: function(file) {
        if (!this.options.importOptions) {
            this.onFileSuccess(file);
            return;
        }

        var url = this.options.completeUrl + "&in=cjson&out=cjson&exi=true&fname=" + encodeURIComponent(file.name);
        if (this.options.waitForComplete)
            url += "&comp=true";

        var data = Base64.encode(JSON.stringify(this.options.importOptions));

        var request = new Librarian.Request.JSON({
            url: url,
            method: "POST",
            data: data,
            onSuccess: function(data) {
                this.onFileSuccess(file, data);
            }.bind(this),
            onFailure: function(error) {
                this.onFileFailure(file, error);
            }.bind(this)
        });

        request.send();
    },

    onFileSuccess: function(file, data) {
        file.status = "success";
        file.data = data;

        if (typeof this.options.onFileSuccess == "function")
            this.options.onFileSuccess(file, data);

        this.successCount++;
        this.checkComplete();
    },

    onFileFailure: function(file, error) {
        file.status = "failure";
        file.error = error;

        if (typeof this.options.onFileFailure == "function")
            this.options.onFileFailure(file, error);

        this.failureCount++;
        this.checkComplete();
    },

    checkComplete: function() {
        if (this.successCount + this.failureCount == this.files.length) {
            if (typeof this.options.onComplete == "function")
                this.options.onComplete(this.files, this.successCount, this.failureCount);

            // Reset
            this.files = [];
            this.successCount = this.failureCount = 0;
        }
    }
    
});